import type { FC } from 'react';

import { Box, Container, useTheme } from '@mui/material';
import { Seo } from '@/components/seo';
import { CommunityPageHeader } from '@/components/common/community-page-header';
import { CalendarBlank as CalendarBlankIcon } from '@phosphor-icons/react/dist/ssr';
import { useParams } from 'react-router-dom';

import MeetingOverview from './components/MeetingOverview';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const MeetingPage: FC = () => {
  const theme = useTheme();
  const { meetingId } = useParams<{ meetingId: string }>();
  
  return (
    <>
      <Seo title="Meeting" />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box
          component="main"
          sx={{ flexGrow: 1, py: 3, backgroundColor: theme.palette.background.default, minHeight: '100vh' }}
        >
          <Container maxWidth="xl">
            <CommunityPageHeader
              breadcrumbs={[
                {
                  label: 'Home',
                  href: '/',
                },
                {
                  label: 'Meetings',
                  href: '/meetings',
                },
                {
                  label: 'Meeting Details',
                },
              ]}
              icon={<CalendarBlankIcon size={36} />}
              subtitle="Review and update meeting details"
              title="Meeting"
            />
            <MeetingOverview />
          </Container>
        </Box>
      </LocalizationProvider>
    </>
  );
};

export default MeetingPage;
